// src/components/atoms/floating-telegram-button.tsx
"use client";

import * as React from "react";
import { Send } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { telegramChatUrl } from "@/lib/telegram";

type Props = {
  handle: string;
  className?: string;
  ariaLabel?: string;
  title?: string;
};

export function FloatingTelegramButton({
  handle,
  className,
  ariaLabel,
  title,
}: Props) {
  const href = telegramChatUrl(handle);
  const label =
    ariaLabel ??
    (handle && handle.trim().length > 0
      ? `Chat on Telegram: ${handle.trim()}`
      : "Chat on Telegram");

  return (
    // Hidden on phones while the cookie banner is open: it spans the full width
    // there and marks <html> with data-cookie-banner-open.
    <div className={cn("fixed bottom-6 right-4 z-50 max-sm:[html[data-cookie-banner-open]_&]:hidden", className)}>
      <div className="mb-2 flex justify-center">
        <span className="rounded-full border bg-background px-2 py-0.5 text-[10px] font-medium text-muted-foreground shadow-sm">
          Support
        </span>
      </div>

      <Button
        asChild
        size="icon"
        className="h-12 w-12 rounded-full shadow-lg bg-[#229ED9] hover:bg-[#1E8FC4] text-white"
      >
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={title ?? label}
        >
          <Send className="h-5 w-5" />
        </a>
      </Button>
    </div>
  );
}